import React from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { purple, blue } from '../data/colors';

const useStyles = makeStyles(theme => ({
    root: {
    },
    progress: {
        border: `1px solid ${theme.palette.divider}`,
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        height: 26,
        borderRadius: 2,
    },
    value: {
        position: 'absolute',
        lineHeight: '24px',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        color: theme.palette.text.primary,
        '&.low': {
            color: theme.palette.mode === 'light' ? 'rgba(100, 100, 100, 1)' : '#FFF',
        },
        '&.medium, &.high': {
            color: theme.palette.mode === 'light' ? 'rgba(175, 175, 175, 1)' : '#FFF',
        },
        '&.done': {
            color: theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 1)' : '#FFF',
        },
    },
    purple: {
        height: '100%',
        '&.low': {
            backgroundColor: purple[100],
        },
        '&.medium': {
            backgroundColor: purple[200],
        },
        '&.high': {
            backgroundColor: purple[300],
        },
        '&.done': {
            backgroundColor: purple[400],
        },
    },
    blue: {
        height: '100%',
        backgroundColor: theme.palette.primary.main,
        // color: 'black',
    },
}));

// shamelessly lifted from the x-grid demo
// https://github.com/mui-org/material-ui-x/blob/31d3633939b25c40c800f8eeb205505b54f45912/packages/grid/x-grid-data-generator/src/renderer/renderProgress.tsx#L62
const ProgressBar = React.memo(function ProgressBar (props) {
    const { value } = props;
    const classes = useStyles();

    return (
        <div className={classes.progress}>
            <div className={clsx(classes.value, {
                low: value < 30,
                medium: value >= 30 && value <= 70,
                high: value > 70 && value <= 100,
                done: value >= 100,
            })}>
                {`${value.toLocaleString()} %`}</div>
            <div
                className={clsx(props.color === 'blue' ? classes.blue : classes.purple, {
                    low: value < 30,
                    medium: value >= 30 && value <= 70,
                    high: value > 70 && value <= 100,
                    done: value >= 100,
                })}
                style={{ maxWidth: `${value}%` }}
            />
        </div>
    );
});
ProgressBar.propTypes = {
    value: PropTypes.number,
    color: PropTypes.string,
};

export default ProgressBar;
